import styled from "@emotion/styled";
import type { ImageObject } from "@ext/markdown/elements/image/edit/model/imageEditorTypes";
import ObjectRenderer from "@ext/markdown/elements/image/render/components/ObjectRenderer";
import { type CSSProperties, forwardRef, type MutableRefObject, memo, useRef } from "react";
import { TransformComponent } from "react-zoom-pan-pinch";

interface ImageProps {
	id: string;
	objects: ImageObject[];
	src?: string;
	svg?: string;
	className?: string;
	modalStyle?: CSSProperties;
	html?: string | TrustedHTML;
}

export type Rect = {
	left: number;
	top: number;
	scale: number;
};

const MediaRenderer = forwardRef((props: ImageProps, ref?: MutableRefObject<HTMLImageElement>) => {
	const { id, className, src, svg, objects = [], modalStyle } = props;
	const imgRef = useRef<HTMLImageElement>();

	return (
		<div className={className}>
			<TransformComponent wrapperClass="transform-wrapper">
				<div className={`image-container ${svg ? "image-container--svg" : ""}`} ref={ref}>
					{svg ? (
						<div
							dangerouslySetInnerHTML={{ __html: svg }}
							draggable={false}
							id={id}
							ref={imgRef}
							style={modalStyle}
						/>
					) : (
						<img alt="" draggable="false" id={id} key={id} ref={imgRef} src={src} style={modalStyle} />
					)}

					<div className="object-container">
						<ObjectRenderer editable={false} imageRef={imgRef} objects={objects} parentRef={ref} />
					</div>
				</div>
			</TransformComponent>
		</div>
	);
});

export default styled(memo(MediaRenderer))`
	justify-items: center;
	align-content: center;
	width: 100%;
	height: 100%;

	.image-container--svg {
		height: 80dvh;
	}

	.image-container--svg div:first-of-type {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
	}

	.image-container--svg div:first-of-type svg {
		max-width: unset !important;
		width: 100% !important;
		height: 100% !important;
	}
`;
